import React, { useEffect, useRef, useState } from "react";
import "./SocialMedia.css";

import linkedin from "../assets/linkedin.png";
import handshake from "../assets/handshake.png";
import github from "../assets/github.png";
import x from "../assets/x.png";
import instagram from "../assets/instagram.png";

const socials = [
  {
    name: "LinkedIn",
    logo: linkedin,
    link: "https://www.linkedin.com/in/ben-booganim-1464651a0",
    side: "left",
  },
  {
    name: "Handshake",
    logo: handshake,
    link: "https://app.joinhandshake.com/profiles/qpmnq3",
    side: "right",
  },
  {
    name: "GitHub",
    logo: github,
    link: "https://github.com/BenBoog04",
    side: "left",
  },
  {
    name: "X",
    logo: x,
    link: "https://x.com/BenBoogani34949",
    side: "right",
  },
  {
    name: "Instagram",
    logo: instagram,
    link: "https://www.instagram.com/ben.booganim/",
    side: "left",
  },
];

function RevealBlock({ children }) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const currentRef = ref.current;

    const observer = new IntersectionObserver(
      ([entry]) => {
        setVisible(entry.isIntersecting);
      },
      { threshold: 0.2 }
    );

    if (currentRef) observer.observe(currentRef);

    return () => {
      if (currentRef) observer.unobserve(currentRef);
    };
  }, []);

  return (
    <div
      ref={ref}
      className={visible ? "social-visible" : "social-hidden"}
    >
      {children}
    </div>
  );
}

export default function SocialMedia() {
  return (
    <div className="social-container">

      <div className="social-header">
        <h1 className="social-title">Social Media</h1>
        <p className="social-subtitle">Find me on here and connect!</p>
      </div>

      <div className="social-list">
        {socials.map((social) => (
          <RevealBlock key={social.name}>
            <a
              href={social.link}
              target="_blank"
              rel="noopener noreferrer"
              className={`social-bar glass-panel ${social.side}`}
            >
              <div className="social-circle">
                <img
                  src={social.logo}
                  alt={social.name}
                  className="social-icon"
                />
              </div>

              <span className="social-name">{social.name}</span>
            </a>
          </RevealBlock>
        ))}
      </div>

    </div>
  );
}